import { useSelector } from '@/api/state';
import { ConnectionControl } from '@/ui/components';
import { AccountsPermissions } from '@payaca/permissions/accounts/accounts.permissions';
import { userHasRequiredPermission } from '@payaca/permissions/permissions.utils';
import * as authActions from '@payaca/store/auth/authActions';
import { FunctionComponent, useMemo, type JSX } from 'react';
import { useDispatch } from 'react-redux';
import { getUserRoles } from '../../../../utils/stateAccessors';
import ZapierLogo from './zapier.png';

const ZapierConnectionControl: FunctionComponent = (): JSX.Element | null => {
  const dispatch = useDispatch();

  const zapierConnection = useSelector((state: any) => {
    if (!state.users.myProfile.oAuthConnections) {
      return null;
    }
    return state.users.myProfile.oAuthConnections.find(
      (p: any) => p.clientName === 'Zapier' || p.clientName === 'zapier test'
    );
  });
  const userRoles = useSelector(getUserRoles);

  const canUpdate = useMemo(() => {
    return userHasRequiredPermission(userRoles, [
      AccountsPermissions.UPDATE_CONNECTION_AUTOMATION,
    ]);
  }, [userRoles]);

  return (
    <ConnectionControl
      connectionName="Zapier"
      isConnected={zapierConnection}
      onRemoveConnection={(onConnectionRemoved: () => void) =>
        dispatch(
          authActions.removeOAuthConnection(
            zapierConnection,
            onConnectionRemoved
          )
        )
      }
      allowConnectDisconnect={canUpdate}
      disconnectionError="Sorry, there was an error removing your connection with Zapier. Please try again or head over to your Zapier account and remove your connection with Payaca."
      logo={ZapierLogo}
      onAddConnection={() =>
        window.open(
          import.meta.env.VITE_ENV === 'staging' ||
            import.meta.env.VITE_APP_ENV === 'development'
            ? 'https://zapier.com/developer/public-invite/125577/2765a5b758bd096b961fbc6995e39164/'
            : 'https://zapier.com/apps/payaca/integrations'
        )
      }
    >
      <p>
        Automate workflows by connecting Payaca with thousands of apps using
        Zapier, streamlining your processes across platforms with ease.
      </p>
    </ConnectionControl>
  );
};

export default ZapierConnectionControl;
